import React from 'react';

/**
 * En-tête de la fiche de paie (informations employeur)
 */
export function PayrollHeader({ cabinet }) {
  if (!cabinet) return null;

  return (
    <div className="payroll-header">
      <div className="payroll-employer-info">
        <h2 className="payroll-employer-name">{cabinet.raison_sociale}</h2>
        <div className="payroll-employer-details">
          <div className="payroll-detail-line">
            <span className="payroll-label">SIRET :</span>
            <span className="payroll-value">{cabinet.siret}</span>
          </div>
          <div className="payroll-detail-line">
            <span className="payroll-label">NAF :</span>
            <span className="payroll-value">{cabinet.naf}</span>
          </div>
          <div className="payroll-detail-line">
            <span className="payroll-label">Convention collective (IDCC) :</span>
            <span className="payroll-value">{cabinet.convention_idcc}</span>
          </div>
        </div>
        {cabinet.adresse && (
          <div className="payroll-employer-address">
            <div>{cabinet.adresse.l1}</div>
            {cabinet.adresse.l2 && <div>{cabinet.adresse.l2}</div>}
            <div>{cabinet.adresse.code_postal} {cabinet.adresse.ville}</div>
            {cabinet.adresse.pays && cabinet.adresse.pays !== 'FR' && (
              <div>{cabinet.adresse.pays}</div>
            )}
          </div>
        )}
      </div>
      <div className="payroll-title-block">
        <h1 className="payroll-document-title">BULLETIN DE PAIE</h1>
      </div>
    </div>
  );
}
